// src/components/TrackingResults.jsx
import React, { useState, useEffect } from 'react';

const TrackingResults = ({ data, onNewSearch }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const getStatusColor = (data) => {
    const {
      StatusCdMeaning,
      MetodoDeEnvioRecoleccionMeaning,
      CondicionesDeCreditoDeLaOrden_c,
      EstadoRutaPedidoMeaning,
    } = data;

    // 1. Recepción de pedido (base y con datos adicionales)
    if (StatusCdMeaning === 'Recepción de pedido') {
      if (
        data.OrdenDeCompraDelCliente_c ||
        data.FechaPromesaDeEntregaRecoleccion_c
      ) {
        return 'bg-gradient-to-r from-emerald-400 to-emerald-500'; // Similar a #22C55E
      }
      return 'bg-gradient-to-r from-green-400 to-green-500'; // Similar a #10B981
    }

    // 2. Ejecutado en OM
    if (StatusCdMeaning === 'Pedido ejecutado en OM') {
      return 'bg-gradient-to-r from-blue-400 to-blue-500'; // Similar a #3B82F6
    }

    // 3. Pedido en tránsito – Ruta Packsys
    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys'
    ) {
      // Estados por horarios específicos
      if (data.HorarioDeSalidaDeUnidad_c)
        return 'bg-gradient-to-r from-sky-400 to-sky-500'; // Similar a #60A5FA
      if (data.HorarioLlegada_c)
        return 'bg-gradient-to-r from-emerald-300 to-emerald-400'; // Similar a #34D399
      if (data.HorarioInicioDescarga_c)
        return 'bg-gradient-to-r from-amber-400 to-amber-500'; // Similar a #F59E0B
      if (data.HorarioSalida_c)
        return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669

      // Estados por EstadoRutaPedidoMeaning
      if (EstadoRutaPedidoMeaning === 'Pedido en ruta')
        return 'bg-gradient-to-r from-indigo-400 to-indigo-500'; // Similar a #6366F1
      if (EstadoRutaPedidoMeaning === 'Llegada con cliente')
        return 'bg-gradient-to-r from-amber-400 to-amber-500'; // Similar a #F59E0B
      if (EstadoRutaPedidoMeaning === 'Pedido entregado')
        return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
      if (EstadoRutaPedidoMeaning === 'Pedido reprogramado')
        return 'bg-gradient-to-r from-purple-400 to-purple-500'; // Similar a #8B5CF6
      if (EstadoRutaPedidoMeaning === 'Pedido rechazado')
        return 'bg-gradient-to-r from-red-400 to-red-500'; // Similar a #EF4444

      return 'bg-gradient-to-r from-sky-400 to-sky-500'; // Por defecto
    }

    // 4. Cliente recoge
    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge'
    ) {
      if (!data.HorarioSalida_c)
        return 'bg-gradient-to-r from-purple-400 to-purple-500'; // Similar a #8B5CF6
      if (data.HorarioSalida_c)
        return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
      return 'bg-gradient-to-r from-purple-400 to-purple-500';
    }

    // 5. Paquetería domicilio
    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      if (EstadoRutaPedidoMeaning === 'Pedido en espera de entrega')
        return 'bg-gradient-to-r from-orange-400 to-orange-500'; // Similar a #F97316
      if (EstadoRutaPedidoMeaning === 'Pedido entregado')
        return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
      if (EstadoRutaPedidoMeaning === 'Pedido rechazado')
        return 'bg-gradient-to-r from-red-400 to-red-500'; // Similar a #EF4444
      return 'bg-gradient-to-r from-cyan-400 to-cyan-500'; // Similar a #0EA5E9
    }

    // 6. Paquetería domicilio - estados finales
    if (
      (StatusCdMeaning === 'Pedido entregado/rechazado' ||
        StatusCdMeaning === 'Cierre de SR' ||
        StatusCdMeaning === 'Cerrada') &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
    }

    if (
      StatusCdMeaning === 'Pedido entregado/rechazado' ||
      StatusCdMeaning === 'Cierre de SR' ||
      StatusCdMeaning === 'Cerrada'
    ) {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
    }

    if (StatusCdMeaning === 'Confirmación de descarga de mercancía') {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
    }

    // 7. Revisión de crédito
    if (StatusCdMeaning === 'Revisión de crédito') {
      if (CondicionesDeCreditoDeLaOrden_c === 'Anticipo') {
        return 'bg-gradient-to-r from-amber-500 to-amber-600'; // Similar a #D97706
      }
      return 'bg-gradient-to-r from-amber-400 to-amber-500'; // Similar a #F59E0B
    }

    // 8. Pedido en espera de envío
    if (StatusCdMeaning === 'Pedido en espera de envío') {
      return 'bg-gradient-to-r from-violet-500 to-violet-600'; // Similar a #7C3AED
    }

    // 9. Pedido facturado
    if (StatusCdMeaning === 'Pedido facturado') {
      return 'bg-gradient-to-r from-blue-500 to-blue-600'; // Similar a #1D4ED8
    }

    // 10. Paquetería ocurre
    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre'
    ) {
      if (EstadoRutaPedidoMeaning === 'Pedido en espera de entrega')
        return 'bg-gradient-to-r from-orange-400 to-orange-500'; // Similar a #F97316
      if (EstadoRutaPedidoMeaning === 'Pedido entregado')
        return 'bg-gradient-to-r from-emerald-500 to-emerald-600'; // Similar a #059669
      if (EstadoRutaPedidoMeaning === 'Pedido rechazado')
        return 'bg-gradient-to-r from-red-400 to-red-500'; // Similar a #EF4444
      return 'bg-gradient-to-r from-cyan-400 to-cyan-500'; // Similar a #0EA5E9
    }

    if (StatusCdMeaning === 'Devolución aprobada') {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600';
    }

    if (StatusCdMeaning === 'En espera de autorización técnica') {
      return 'bg-gradient-to-r from-violet-500 to-violet-600';
    }

    if (StatusCdMeaning === 'En espera de programación') {
      return 'bg-gradient-to-r from-amber-400 to-amber-500';
    }

    if (StatusCdMeaning === 'Error Ventas') {
      return 'bg-gradient-to-r from-red-400 to-red-500';
    }

    if (
      StatusCdMeaning === 'Error por inventario (Compras)' ||
      StatusCdMeaning === 'Material sin Disponibilidad (Ventas)'
    ) {
      return 'bg-gradient-to-r from-red-400 to-red-500';
    }

    if (StatusCdMeaning === 'NC aplicada') {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600';
    }

    if (StatusCdMeaning === 'Pedido enviado a CPQ') {
      return 'bg-gradient-to-r from-emerald-500 to-emerald-600';
    }

    if (StatusCdMeaning === 'Recepción de rechazo') {
      return 'bg-gradient-to-r from-orange-400 to-orange-500';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de devolución') {
      return 'bg-gradient-to-r from-purple-400 to-purple-500';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de recolección') {
      return 'bg-gradient-to-r from-purple-400 to-purple-500';
    }

    if (
      StatusCdMeaning === 'Rechazo en tránsito' ||
      StatusCdMeaning === 'Recolección en tránsito'
    ) {
      return 'bg-gradient-to-r from-cyan-400 to-cyan-500';
    }

    // Estado por defecto
    return 'bg-gradient-to-r from-gray-400 to-gray-500'; // Similar a #6B7280
  };

  const getStatusIcon = (data) => {
    const {
      StatusCdMeaning,
      MetodoDeEnvioRecoleccionMeaning,
      CondicionesDeCreditoDeLaOrden_c,
      EstadoRutaPedidoMeaning,
    } = data;

    if (StatusCdMeaning === 'Recepción de pedido') return '✅';
    if (StatusCdMeaning === 'Pedido ejecutado en OM') return '🏢';

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys'
    ) {
      if (data.HorarioDeSalidaDeUnidad_c) return '🚚💨';
      if (data.HorarioLlegada_c) return '📍';
      if (data.HorarioInicioDescarga_c) return '🤝';
      if (data.HorarioSalida_c) return '📦✅';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge'
    ) {
      if (!data.HorarioSalida_c) return '📬';
      if (data.HorarioSalida_c) return '📦🏢';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return '📦🚚';
    }

    if (
      (StatusCdMeaning === 'Pedido entregado/rechazado' ||
        StatusCdMeaning === 'Cierre de SR' ||
        StatusCdMeaning === 'Cerrada') &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return '🎉📦';
    }

    if (
      StatusCdMeaning === 'Pedido entregado/rechazado' ||
      StatusCdMeaning === 'Cierre de SR' ||
      StatusCdMeaning === 'Cerrada'
    ) {
      return '📦✅';
    }

    if (StatusCdMeaning === 'Confirmación de descarga de mercancía') {
      return '📤✅';
    }

    if (
      StatusCdMeaning === 'Recepción de pedido' &&
      (data.OrdenDeCompraDelCliente_c ||
        data.FechaPromesaDeEntregaRecoleccion_c)
    ) {
      return '📨';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c === 'Anticipo'
    ) {
      return '💳⌛';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c !== 'Anticipo'
    ) {
      return '🧾⌛';
    }

    if (StatusCdMeaning === 'Pedido en espera de envío') {
      return '🛠️';
    }

    if (StatusCdMeaning === 'Pedido facturado') {
      return '🧾✅';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido en ruta'
    ) {
      return '🗺️🚚';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Llegada con cliente'
    ) {
      return '🤝';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Inicio de descarga'
    ) {
      return '📤';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '📦✅';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido reprogramado'
    ) {
      return '🔁';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return '❌📦';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return '🏪📦';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '📦✅';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return '❌📦';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return '🚛➡️';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '📦✅';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return '❌📦';
    }

    if (StatusCdMeaning === 'Devolución aprobada') {
      return '♻️📦';
    }

    if (StatusCdMeaning === 'En espera de autorización técnica') {
      return '🛠️⌛';
    }

    if (StatusCdMeaning === 'En espera de programación') {
      return '🗓️✔️';
    }

    if (StatusCdMeaning === 'Error Ventas') {
      return '🔎📄';
    }

    if (
      StatusCdMeaning === 'Error por inventario (Compras)' ||
      StatusCdMeaning === 'Material sin Disponibilidad (Ventas)'
    ) {
      return '📊📦';
    }

    if (StatusCdMeaning === 'NC aplicada') {
      return '🧾💰';
    }

    if (StatusCdMeaning === 'Pedido enviado a CPQ') {
      return '📄✔️';
    }

    if (StatusCdMeaning === 'Recepción de rechazo') {
      return '📨❌';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de devolución') {
      return '♻️🏢';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de recolección') {
      return '📬🏢';
    }

    if (StatusCdMeaning === 'Rechazo en tránsito') {
      return '❌🚚💨';
    }

    if (StatusCdMeaning === 'Recolección en tránsito') {
      return '📬🚚💨';
    }

    return '📄';
  };

  const getStatusText = (data) => {
    const {
      StatusCdMeaning,
      MetodoDeEnvioRecoleccionMeaning,
      CondicionesDeCreditoDeLaOrden_c,
      EstadoRutaPedidoMeaning,
    } = data;

    if (StatusCdMeaning === 'Recepción de pedido') return 'PEDIDO CONFIRMADO';
    if (StatusCdMeaning === 'Pedido ejecutado en OM')
      return 'PEDIDO EN ALMACÉN';

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys'
    ) {
      if (data.HorarioDeSalidaDeUnidad_c) return 'PEDIDO EN CAMINO';
      if (data.HorarioLlegada_c) return 'HEMOS LLEGADO';
      if (data.HorarioInicioDescarga_c) return 'PEDIDO EN ENTREGA';
      if (data.HorarioSalida_c) return 'PEDIDO ENTREGADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge'
    ) {
      if (!data.HorarioSalida_c) return 'LISTO PARA RECOGER';
      if (data.HorarioSalida_c) return 'RECOGIDO EN ALMACÉN';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return 'ENVIADO POR PAQUETERÍA';
    }

    if (
      (StatusCdMeaning === 'Pedido entregado/rechazado' ||
        StatusCdMeaning === 'Cierre de SR' ||
        StatusCdMeaning === 'Cerrada') &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return 'ENTREGADO POR PAQUETERÍA';
    }

    if (
      StatusCdMeaning === 'Pedido entregado/rechazado' ||
      StatusCdMeaning === 'Cierre de SR' ||
      StatusCdMeaning === 'Cerrada' ||
      StatusCdMeaning === 'Confirmación de descarga de mercancía'
    ) {
      return 'PEDIDO ENTREGADO';
    }

    if (
      StatusCdMeaning === 'Recepción de pedido' &&
      (data.OrdenDeCompraDelCliente_c ||
        data.FechaPromesaDeEntregaRecoleccion_c)
    ) {
      return 'PAGO RECIBIDO';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c === 'Anticipo'
    ) {
      return 'PAGO PENDIENTE';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c !== 'Anticipo'
    ) {
      return 'CRÉDITO RETENIDO';
    }

    if (StatusCdMeaning === 'Pedido en espera de envío') {
      return 'EN PREPARACIÓN';
    }

    if (StatusCdMeaning === 'Pedido facturado') {
      return 'PEDIDO FACTURADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido en ruta'
    ) {
      return 'PEDIDO EN RUTA';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Llegada con cliente'
    ) {
      return 'PEDIDO EN ENTREGA';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Inicio de descarga'
    ) {
      return 'PEDIDO EN DESCARGA';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return 'PEDIDO ENTREGADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido reprogramado'
    ) {
      return 'PEDIDO REPROGRAMADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'PEDIDO RECHAZADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return 'LISTO EN SUCURSAL';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return 'PEDIDO ENTREGADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'PEDIDO RECHAZADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return 'PEDIDO EN TRÁNSITO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return 'PEDIDO ENTREGADO';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'PEDIDO RECHAZADO';
    }

    if (StatusCdMeaning === 'Devolución aprobada') {
      return 'PEDIDO EN DEVOLUCIÓN';
    }

    if (StatusCdMeaning === 'En espera de autorización técnica') {
      return 'PEDIDO EN APROBACIÓN';
    }

    if (StatusCdMeaning === 'En espera de programación') {
      return 'PEDIDO AUTORIZADO';
    }

    if (StatusCdMeaning === 'Error Ventas') {
      return 'PEDIDO EN REVISIÓN';
    }

    if (
      StatusCdMeaning === 'Error por inventario (Compras)' ||
      StatusCdMeaning === 'Material sin Disponibilidad (Ventas)'
    ) {
      return 'PEDIDO EN REVISIÓN';
    }

    if (StatusCdMeaning === 'NC aplicada') {
      return 'PEDIDO CON CRÉDITO LISTO';
    }

    if (StatusCdMeaning === 'Pedido enviado a CPQ') {
      return 'PEDIDO FACTURADO';
    }

    if (StatusCdMeaning === 'Recepción de rechazo') {
      return 'SOLICITUD RECIBIDA';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de devolución') {
      return 'PEDIDO EN DEVOLUCIÓN';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de recolección') {
      return 'PEDIDO EN ALMACÉN';
    }

    if (
      StatusCdMeaning === 'Rechazo en tránsito' ||
      StatusCdMeaning === 'Recolección en tránsito'
    ) {
      return 'PEDIDO EN CAMINO';
    }

    return StatusCdMeaning;
  };

  const getLargeStatusText = (data) => {
    const {
      StatusCdMeaning,
      MetodoDeEnvioRecoleccionMeaning,
      CondicionesDeCreditoDeLaOrden_c,
      EstadoRutaPedidoMeaning,
    } = data;

    if (StatusCdMeaning === 'Recepción de pedido')
      return 'Pedido recibido y pago confirmado.';
    if (StatusCdMeaning === 'Pedido ejecutado en OM')
      return 'Tu pedido ha sido enviado a almacén.';

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys'
    ) {
      if (data.HorarioDeSalidaDeUnidad_c)
        return 'Inicio del trayecto. Vamos en camino.';
      if (data.HorarioLlegada_c) return 'Llegamos a tu ubicación.';
      if (data.HorarioInicioDescarga_c) return 'Estamos entregándote.';
      if (data.HorarioSalida_c)
        return '¡Listo! Hemos entregado tu pedido con éxito.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge'
    ) {
      if (!data.HorarioSalida_c)
        return 'Tu pedido está listo. Puedes pasar por él.';
      if (data.HorarioSalida_c) return 'Pedido recogido en nuestro almacén.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return 'La paquetería está enviando tu pedido.';
    }

    if (
      (StatusCdMeaning === 'Pedido entregado/rechazado' ||
        StatusCdMeaning === 'Cierre de SR' ||
        StatusCdMeaning === 'Cerrada') &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio'
    ) {
      return 'La paquetería ha entregado tu pedido. Gracias por tu preferencia, ¡vuelve pronto!';
    }

    if (
      StatusCdMeaning === 'Pedido entregado/rechazado' ||
      StatusCdMeaning === 'Cierre de SR' ||
      StatusCdMeaning === 'Cerrada'
    ) {
      return 'Tu pedido ha sido entregado con nuestro servicio de Ruta Packsys. ¡Vuelve pronto!';
    }

    if (StatusCdMeaning === 'Confirmación de descarga de mercancía') {
      return 'Descarga finalizada: el pedido ya está en destino.';
    }

    if (
      StatusCdMeaning === 'Recepción de pedido' &&
      (data.OrdenDeCompraDelCliente_c ||
        data.FechaPromesaDeEntregaRecoleccion_c)
    ) {
      return 'Tu pedido ha sido recibido.';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c === 'Anticipo'
    ) {
      return 'Tu pedido está pendiente de pago.';
    }

    if (
      StatusCdMeaning === 'Revisión de crédito' &&
      CondicionesDeCreditoDeLaOrden_c !== 'Anticipo'
    ) {
      return 'Tu pedido está detenido por crédito. Si tienes dudas, contacta a Servicio a Cliente.';
    }

    if (StatusCdMeaning === 'Pedido en espera de envío') {
      return 'Tu pedido está siendo preparado.';
    }

    if (StatusCdMeaning === 'Pedido facturado') {
      return 'Tu pedido se encuentra facturado.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido en ruta'
    ) {
      return 'Se ha iniciado la ruta de tu pedido.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Llegada con cliente'
    ) {
      return 'Estamos contigo para entregar.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Inicio de descarga'
    ) {
      return 'Se ha comenzado la descarga de tu pedido.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '¡Listo! Hemos entregado tu pedido con éxito.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido reprogramado'
    ) {
      return 'Se reprogramó por solicitud del cliente o llegamos fuera de horario.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'Haz rechazado el pedido.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return 'Ya puedes recolectar tu pedido en la sucursal de Paquetexpress.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '¡Listo! Hemos entregado tu pedido con éxito.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería ocurre' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'Haz rechazado el pedido.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido en espera de entrega'
    ) {
      return 'Tu pedido está en tránsito.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido entregado'
    ) {
      return '¡Listo! Hemos entregado tu pedido con éxito.';
    }

    if (
      StatusCdMeaning === 'Pedido en tránsito' &&
      MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
      EstadoRutaPedidoMeaning === 'Pedido rechazado'
    ) {
      return 'Haz rechazado el pedido.';
    }

    if (StatusCdMeaning === 'Devolución aprobada') {
      return 'Tu solicitud de devolución fue aprobada.';
    }

    if (StatusCdMeaning === 'En espera de autorización técnica') {
      return 'Estamos esperando la aprobación del área técnica.';
    }

    if (StatusCdMeaning === 'En espera de programación') {
      return 'Autorizado: estamos esperando la asignación de fecha de recolección.';
    }

    if (StatusCdMeaning === 'Error Ventas') {
      return 'En revisión antes de ingresar el pedido.';
    }

    if (
      StatusCdMeaning === 'Error por inventario (Compras)' ||
      StatusCdMeaning === 'Material sin Disponibilidad (Ventas)'
    ) {
      return 'Pedido en revisión de inventario.';
    }

    if (StatusCdMeaning === 'NC aplicada') {
      return 'Tu nota de credito esta lista.';
    }

    if (StatusCdMeaning === 'Pedido enviado a CPQ') {
      return 'Tu factura está lista.';
    }

    if (StatusCdMeaning === 'Recepción de rechazo') {
      return 'Hemos recibido tu solicitud de rechazo.';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de devolución') {
      return 'Hemos recibido tu solicitud de devolución. El material se encuentra en almacén.';
    }

    if (StatusCdMeaning === 'Recepción de solicitud de recolección') {
      return 'Hemos recibido tu solicitud de recolección. El material se encuentra en almacén.';
    }

    if (
      StatusCdMeaning === 'Rechazo en tránsito' ||
      StatusCdMeaning === 'Recolección en tránsito'
    ) {
      return 'Inicio del trayecto. Vamos en camino.';
    }

    return StatusCdMeaning;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'No disponible';
    try {
      const date = new Date(dateString.replace('TT', 'T'));
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  // En TrackingResults.jsx - actualizar la función getTimelineSteps
  const getTimelineSteps = () => {
    const isPaqueteria =
      data.MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio';
    const isPickup = data.MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge';

    // Lógica base para todos los métodos de envío
    let steps = [
      {
        code: 'created',
        title: 'Pedido Creado',
        description: 'Tu pedido ha sido registrado en el sistema',
        date: data.CreationDate,
        icon: '📦',
        completed: true,
        visible: true,
      },
      {
        code: 'transit',
        title: 'En Tránsito',
        description: 'Tu pedido está en camino',
        date: data.HorarioDeSalidaDeUnidad_c,
        icon: '🚚',
        completed: !!data.HorarioDeSalidaDeUnidad_c,
        visible: !isPaqueteria, // No mostrar para paquetería
      },
      /*
      {
        code: 'arrival',
        title: 'Llegada',
        description: 'Tu pedido ha llegado al destino',
        date: data.HorarioLlegada_c,
        icon: '🏠',
        completed: !!data.HorarioLlegada_c,
        visible: !isPaqueteria, // No mostrar para paquetería
      },
      {
        code: 'unloading',
        title: 'Inicio Descarga',
        description: 'En proceso de descarga',
        date: data.HorarioInicioDescarga_c,
        icon: '📋',
        completed: !!data.HorarioInicioDescarga_c,
        visible: !isPaqueteria && !isPickup, // No mostrar para paquetería ni recogida
      },*/
      {
        code: 'delivered',
        title: isPickup ? 'Recogido' : 'Entregado',
        description: isPickup
          ? 'Pedido recogido exitosamente'
          : 'Pedido entregado exitosamente',
        date: data.HorarioSalida_c,
        icon: isPickup ? '🛍️' : '✅',
        completed: !!data.HorarioSalida_c,
        visible: true,
      },
    ];

    // ✅ NUEVA LÓGICA PARA PAQUETERÍA - 3 STEPS ESPECÍFICOS
    if (isPaqueteria) {
      steps = [
        // Step 1: Pedido Creado (siempre visible)
        {
          code: 'created',
          title: 'Pedido Creado',
          description: 'Tu pedido ha sido registrado en el sistema',
          date: data.CreationDate,
          icon: '📦',
          completed: true,
          visible: true,
        },
        // Step 2: Enviado por Paquetería (depende de StatusTypeCdMeaning)
        {
          code: 'shipped',
          title: 'Enviado por Paquetería',
          description: 'Tu pedido ha sido enviado con paquetería externa',
          date: data.HorarioSalida_c, // Usar fecha de salida si existe
          icon: '📮',
          completed: data.Guia_c,
          visible: true,
        },
        // Step 3: Entregado (depende de HorarioSalida_c)
        {
          code: 'delivered',
          title: 'Entregado',
          description: 'Pedido entregado exitosamente',
          date: data.HorarioSalida_c,
          icon: '✅',
          completed: !!data.HorarioSalida_c,
          visible: true,
        },
      ];
    }

    // Para recogida en tienda, mostramos solo creación y recogida
    if (isPickup) {
      steps = steps.map((step) => ({
        ...step,
        // Solo mostrar creación y recogida
        visible: step.code === 'created' || step.code === 'delivered',
      }));
    }

    return steps.filter((step) => step.visible);
  };

  const getOriginInfo = () => {
    return {
      legalName: data.LegalEntityName || 'PEDIDO SIN ORIGEN ASIGNADO',
      organizationName: data.OrganizationName || 'PEDIDO SIN ORIGEN ASIGNADO',
      otherName: data.AccountPartyName,
      otherOrganization: data.Title,
      almacen: data.Almacen_c,
      almacen2: data.RequestedFulfillmentOrganizationCode,
      address: data.PropietarioDeLaCuenta_c || 'Centro de distribución',
      address1: data.AddressLine1Origin,
      address2: data.AddressLine2Origin,
      address3: data.AddressLine3Origin,
      address4: data.AddressLine4Origin,
      postalCode: data.PostalCodeOrigin,
      region1: data.Region1Origin,
      region2: data.Region2Origin,
      region3: data.Region3Origin,
      townOrCity: data.TownOrCityOrigin,
      icon: getChannelIcon(data.AccountPartyName),
    };
  };

  const getDestinationInfo = () => {
    return {
      name: data.PrimaryContactPartyName || 'Cliente',
      name2: data.AccountPartyName,
      destination: data.NombreDeSitio_c,
      address1: data.ShipToAddress1,
      address2: data.ShipToAddress2,
      address3: data.ShipToAddress3,
      postalCode: data.ShipToPostalCode,
      taxpayerIdentificationNumber: data.TaxpayerIdentificationNumber,
      city: data.ShipToCity,
      state: data.ShipToState,
      phone: data.PrimaryContactFormattedPhoneNumber,
    };
  };

  const getChannelIcon = (accountName) => {
    if (!accountName) return '🏢';

    const channelMap = {
      'TIENDA PACKSYS': '🏪',
      'AMAZON PACKSYS': '📦',
      MERCADOLIBRE: '🛒',
      Packsys: '🏢',
    };

    return channelMap[accountName] || '🏢';
  };

  const getShippingMethodInfo = () => {
    const method = data.MetodoDeEnvioRecoleccionMeaning;
    const methodMap = {
      'Ruta Packsys': { icon: '🚛', color: 'text-blue-600', bg: 'bg-blue-50' },
      'Paquetería domicilio': {
        icon: '📮',
        color: 'text-green-600',
        bg: 'bg-green-50',
      },
      'Cliente recoge': {
        icon: '👤',
        color: 'text-purple-600',
        bg: 'bg-purple-50',
      },
    };

    return (
      methodMap[method] || {
        icon: '🚚',
        color: 'text-gray-600',
        bg: 'bg-gray-50',
      }
    );
  };

  const handleNewSearch = () => {
    console.log('🔄 Iniciando nueva búsqueda (preservando cache)...');

    // ✅ NO limpiar localStorage aquí
    // Los datos permanecen para cuando el usuario regrese

    // ✅ Solo navegar a la ruta base
    if (window.location.pathname !== '/tracking') {
      window.history.replaceState(null, '', '/tracking');
    }

    // ✅ Llamar a la función original (solo reset visual)
    onNewSearch();
  };

  const timelineSteps = getTimelineSteps();
  const origin = getOriginInfo();
  const destination = getDestinationInfo();
  const shippingMethod = getShippingMethodInfo();

  // Determinar si es entrega por paquetería externa
  const isExternalCourier =
    data.MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
    data.Guia_c;
  const isPickup = data.MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge';

  const visibleItems = [
    true, // Número de Orden (siempre visible)
    true, // Orden de Compra (siempre visible)
    !!data.NoOrdenCPQ_c, // No. CPQ (condicional)
    !!data.MetodoDeEnvioRecoleccionMeaning, // Método de Envío (condicional)
  ].filter(Boolean).length;

  // Determina el número de columnas según la cantidad de elementos
  const getGridCols = () => {
    if (visibleItems === 1) return 'grid-cols-1';
    if (visibleItems === 2) return 'grid-cols-1 sm:grid-cols-2';
    if (visibleItems === 3) return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3';
    return 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4';
  };

  // Función para obtener el texto dinámico según la fecha
  const getEstimatedDeliveryText = () => {
    if (isDelivered()) {
      return '🎉 ¡Pedido entregado!';
    }

    const fechaEntrega = new Date(data.FechaPromesaDeEntregaRecoleccion_c);
    const hoy = new Date();

    // Resetear horas para comparar solo fechas
    hoy.setHours(0, 0, 0, 0);
    fechaEntrega.setHours(0, 0, 0, 0);

    const diffTime = fechaEntrega - hoy;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return '🎉 ¡Llega hoy!';
    } else if (diffDays === 1) {
      return '📅 Llega mañana';
    } else if (diffDays <= 3) {
      return `📅 Llega este ${getDayName(fechaEntrega)}`;
    } else if (diffDays <= 7) {
      return `📅 Llega en ${diffDays} días`;
    } else {
      return `📅 Llega el ${formatEstimatedDate(data.FechaPromesaDeEntregaRecoleccion_c)}`;
    }
  };

  // Función para obtener el nombre del día
  const getDayName = (fecha) => {
    const dias = [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ];
    return dias[fecha.getDay()];
  };

  // Función para formatear la fecha de manera bonita
  const formatEstimatedDate = (fechaPromesa) => {
    const fecha = new Date(fechaPromesa);
    return fecha
      .toLocaleDateString('es-ES', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      })
      .replace(/^\w/, (c) => c.toUpperCase()); // Capitalizar primera letra
  };

  // Función para calcular días restantes
  const getDaysRemaining = () => {
    if (isDelivered()) return 'Entregado';

    const fechaEntrega = new Date(data.FechaPromesaDeEntregaRecoleccion_c);
    const hoy = new Date();

    hoy.setHours(0, 0, 0, 0);
    fechaEntrega.setHours(0, 0, 0, 0);

    const diffTime = fechaEntrega - hoy;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return 'Hoy';
    if (diffDays === 1) return '1 día';
    return `${diffDays} días`;
  };

  // Función para calcular el progreso de la barra (máximo 14 días para referencia)
  const getDeliveryProgress = () => {
    if (isDelivered()) return 100;

    const fechaEntrega = new Date(data.FechaPromesaDeEntregaRecoleccion_c);
    const hoy = new Date();
    const fechaPedido = new Date(data.CreationDate || hoy);

    // Calcular progreso basado en días transcurridos vs días totales
    const totalTime = fechaEntrega - fechaPedido;
    const elapsedTime = hoy - fechaPedido;

    if (totalTime <= 0) return 100;

    let progress = (elapsedTime / totalTime) * 100;

    // Limitar entre 0 y 100
    return Math.min(Math.max(Math.round(progress), 0), 100);
  };

  const isDelivered = () => {
    // Verificar si el último paso del timeline (Entregado/Recogido) está completado
    const lastStep = timelineSteps[timelineSteps.length - 1];
    return lastStep?.completed || !!data.HorarioSalida_c;
  };

  return (
    <div
      className={`w-full max-w-7xl mx-auto space-y-6 lg:space-y-8 px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      {/* Header Principal Mejorado */}
      <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 transform transition-all duration-700 hover:shadow-3xl">
        <div className="flex flex-col items-center text-center gap-5 mb-8">
          <div className="flex flex-col sm:flex-row items-center gap-5 justify-center w-full">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center shadow-lg">
              <span className="text-xl text-white">📦</span>
            </div>
            <h1 className="text-3xl lg:text-5xl bg-clip-text text-black font-black">
              Seguimiento de Pedido
            </h1>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center lg:justify-between items-center lg:items-start gap-6 mb-6">
          <div className="w-full sm:w-auto">
            <div className="flex flex-col items-center">
              <div className={`grid ${getGridCols()} gap-3 w-full`}>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-4 border border-blue-200 shadow-sm">
                  <span className="font-semibold text-blue-700 text-sm">
                    Número de Orden
                  </span>
                  <p className="text-gray-800 font-bold text-lg mt-1 truncate md:text-wrap">
                    {data.SrNumber}
                  </p>
                </div>
                {data.OrdenDeCompraDelCliente_c && (
                  <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-4 border border-green-200 shadow-sm">
                    <span className="font-semibold text-green-700 text-sm">
                      Orden de Compra
                    </span>
                    <p className="text-gray-800 font-bold text-lg mt-1 truncate md:text-wrap ">
                      {data.OrdenDeCompraDelCliente_c}
                    </p>
                  </div>
                )}
                {data.NoOrdenCPQ_c && (
                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-4 border border-purple-200 shadow-sm">
                    <span className="font-semibold text-purple-700 text-sm">
                      No. CPQ
                    </span>
                    <p className="text-gray-800 font-bold text-lg mt-1 truncate md:text-wrap">
                      {data.NoOrdenCPQ_c}
                    </p>
                  </div>
                )}
                {data.MetodoDeEnvioRecoleccionMeaning && (
                  <div
                    className={`rounded-2xl p-4 border shadow-sm ${shippingMethod.bg} border-gray-200`}
                  >
                    <span className="font-semibold text-gray-700 text-sm">
                      Método de Envío
                    </span>
                    <p className="text-gray-800 font-bold text-lg mt-1 truncate md:text-wrap">
                      <span className="text-lg mr-2">
                        {shippingMethod.icon}
                      </span>
                      {data.MetodoDeEnvioRecoleccionMeaning}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center lg:items-end gap-3 w-full lg:w-[50%]">
            <div
              className={`inline-flex items-center px-6 py-3 rounded-2xl text-white font-bold text-lg shadow-lg ${getStatusColor(
                data
              )}`}
            >
              <span className="mr-2 text-xl">{getStatusIcon(data)}</span>
              {getStatusText(data)}
            </div>
            <p className="text-gray-700 text-md font-bold text-center lg:text-right">
              {getLargeStatusText(data)}
            </p>
            {data.LastUpdateDate && (
              <p className="text-gray-500 text-sm text-center lg:text-right">
                Actualizado: {formatDate(data.LastUpdateDate)}
              </p>
            )}
          </div>
        </div>

        {/* Sección de Fecha Estimada de Entrega */}
        {data.FechaPromesaDeEntregaRecoleccion_c &&
          data.AccountPartyName === 'TIENDA PACKSYS' && (
            <div className="mb-8 transform transition-all duration-700">
              <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 hover:shadow-3xl">
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div
                      className={`bg-gradient-to-br rounded-2xl p-3 shadow-lg ${
                        isDelivered()
                          ? 'from-green-500 to-green-600'
                          : 'from-amber-400 to-amber-500'
                      }`}
                    >
                      <span className="text-2xl">
                        {isDelivered() ? '✅' : '📦'}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-sm font-medium">
                        {isDelivered()
                          ? 'Fecha de entrega'
                          : 'Fecha estimada de entrega'}
                      </p>
                      <h2 className="text-2xl lg:text-3xl font-bold text-gray-800">
                        {getEstimatedDeliveryText()}
                      </h2>
                    </div>
                  </div>

                  <div className="flex items-center gap-4 lg:justify-end">
                    <div className="text-right">
                      <p className="text-gray-500 text-sm">
                        {isDelivered() ? 'Se entregó el' : 'Llega el'}
                      </p>
                      <p className="text-xl font-bold text-gray-800">
                        {isDelivered()
                          ? formatEstimatedDate(
                              data.HorarioSalida_c ||
                                data.FechaPromesaDeEntregaRecoleccion_c
                            )
                          : formatEstimatedDate(
                              data.FechaPromesaDeEntregaRecoleccion_c
                            )}
                      </p>
                    </div>
                    {isDelivered() && (
                      <div className="bg-green-500 rounded-xl px-4 py-2 border border-green-600">
                        <span className="text-white font-semibold text-sm">
                          ¡ENTREGADO!
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Barra de progreso de días restantes - solo mostrar si NO está entregado */}
                {!isDelivered() && (
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-3">
                      <span className="text-sm text-gray-600">
                        Tiempo restante:
                      </span>
                      <div className="flex-1 h-2 bg-gray-100 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-gradient-to-r from-green-400 to-green-500 rounded-full"
                          style={{ width: `${getDeliveryProgress()}%` }}
                        ></div>
                      </div>
                      <span className="text-sm font-bold text-gray-800">
                        {getDaysRemaining()}
                      </span>
                    </div>
                  </div>
                )}

                {/* Mensaje de confirmación de entrega */}
                {isDelivered() && (
                  <div className="mt-6 pt-4 border-t border-gray-100">
                    <div className="flex items-center gap-2 text-green-600 bg-green-50 rounded-xl p-3">
                      <span className="text-xl">🎉</span>
                      <p className="text-sm font-medium">
                        ¡Tu pedido fue entregado exitosamente! Gracias por tu
                        compra.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

        {/* Sección de Timeline Mejorada */}
        <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 transform transition-all duration-700 hover:shadow-3xl">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
            <span className="text-2xl">📊</span>
            Progreso del Pedido
          </h3>

          <div className="relative">
            {/* Línea de tiempo desktop */}
            <div className="hidden lg:flex items-center justify-between relative mb-12">
              {timelineSteps.map((step, index) => (
                <div
                  key={step.code}
                  className="flex flex-col items-center relative z-10 flex-1"
                >
                  {/* Línea conectora - solo mostrar si no es el último paso visible */}
                  {index < timelineSteps.length - 1 && (
                    <div
                      className={`absolute top-10 left-1/2 w-full h-2 -z-10 transition-all duration-1000 ${
                        step.completed
                          ? 'bg-gradient-to-r from-green-400 to-green-500'
                          : 'bg-gray-200'
                      }`}
                      style={{ transitionDelay: `50ms` }}
                    ></div>
                  )}

                  {/* Círculo de estatus animado */}
                  <div
                    className={`w-20 h-20 rounded-2xl flex flex-col items-center justify-center border-4 shadow-lg transform transition-all duration-1000 ${
                      step.completed
                        ? 'bg-gradient-to-br from-green-500 to-green-600 border-green-600 text-white scale-110'
                        : 'bg-white border-gray-300 text-gray-400 scale-100'
                    } mb-4 hover:scale-105 cursor-pointer`}
                    style={{ transitionDelay: `50ms` }}
                  >
                    <span className="text-2xl mb-1">{step.icon}</span>
                    <span className="text-xs font-bold bg-white/20 px-2 py-1 rounded-full">
                      {index + 1}
                    </span>
                  </div>

                  {/* Información del paso */}
                  <div className="text-center max-w-xs transform transition-all duration-1000">
                    <h4
                      className={`font-bold text-sm mb-2 transition-colors duration-300 ${
                        step.completed ? 'text-green-600' : 'text-gray-400'
                      }`}
                    >
                      {step.title}
                    </h4>
                    {/*
                  <p className="text-xs text-gray-500 mb-2 leading-relaxed">
                    {step.description}
                  </p>
                  */}
                    {step.date && step.completed && (
                      <p className="text-xs text-gray-400 bg-gray-50 px-2 py-1 rounded-lg">
                        {formatDate(step.date)}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Línea de tiempo móvil */}
            <div className="lg:hidden space-y-8">
              {timelineSteps.map((step, index) => (
                <div key={step.code} className="flex flex-col items-center">
                  {/* Contenedor del ícono y línea vertical */}
                  <div className="flex items-start w-full">
                    {/* Línea vertical e ícono */}
                    <div className="flex flex-col items-center mr-4">
                      <div
                        className={`w-16 h-16 rounded-2xl flex items-center justify-center border-4 shadow-lg transform transition-all duration-500 ${
                          step.completed
                            ? 'bg-gradient-to-br from-green-500 to-green-600 border-green-600 text-white scale-105'
                            : 'bg-white border-gray-300 text-gray-400'
                        }`}
                      >
                        <span className="text-xl">{step.icon}</span>
                      </div>
                      {index < timelineSteps.length - 1 && (
                        <div
                          className={`flex-1 w-1 mt-2 transition-all duration-500 ${
                            step.completed ? 'bg-green-400' : 'bg-gray-200'
                          }`}
                          style={{ height: '40px' }}
                        ></div>
                      )}
                    </div>

                    {/* Contenido al lado derecho */}
                    <div className="flex-1 pt-2">
                      <h4
                        className={`font-bold text-base mb-1 ${
                          step.completed ? 'text-green-600' : 'text-gray-400'
                        }`}
                      >
                        {step.title}
                      </h4>
                      {step.date && step.completed && (
                        <div className="hidden sm:flex mt-2">
                          <p className="text-xs text-gray-400 bg-gray-50 px-3 py-2 rounded-lg w-full">
                            {formatDate(step.date)}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Fecha debajo del ícono y su línea */}
                  {step.date && step.completed && (
                    <div className="flex sm:hidden mt-2 w-full">
                      <p className="text-xs text-gray-400 bg-gray-50 px-3 py-2 rounded-lg w-full">
                        {formatDate(step.date)}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Sección Origen / Destino Mejorada */}
      <div className="bg-gradient-to-r from-blue-50 via-white to-orange-50 rounded-2xl p-6 border border-gray-200 shadow-inner">
        <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
          <span className="text-2xl">🛣️</span>
          Ruta de Envío
        </h3>
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Origen */}
          <div className="text-center lg:text-left flex-1 w-full">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-blue-200 transform transition-all duration-500 hover:scale-105">
              <div className="w-20 h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto lg:mx-auto mb-4 shadow-lg">
                <span className="text-3xl text-white">{origin.icon}</span>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">Origen</h4>
              <p className="font-semibold text-blue-600 text-lg">
                {origin.legalName || origin.otherName}
              </p>
              {/*
                <p className="text-gray-600 text-sm mt-2">
                  {origin.almacen || origin.almacen2}
                </p>
                */}
              <p className="text-gray-500 text-sm">
                {origin.region1 && origin.townOrCity ? (
                  <>
                    {origin.region1},{' '}
                    {(origin.townOrCity || '').toUpperCase() === 'MEXICO'
                      ? 'ESTADO DE MÉXICO'
                      : (origin.townOrCity || '').toUpperCase()}
                  </>
                ) : (
                  // fallback: show whichever is available
                  origin.region1 || (origin.townOrCity || '').toUpperCase()
                )}
              </p>
            </div>
          </div>
          {/* Flecha de conexión animada */}
          <div className="hidden lg:flex items-center justify-center px-4">
            <div className="flex items-center animate-pulse">
              <div className="w-6 h-6 bg-blue-500 rounded-full"></div>
              <div className="w-24 h-1 bg-blue-500"></div>
              <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-orange-500 rounded-full"></div>
              <div className="w-24 h-1 bg-orange-500"></div>
              <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
            </div>
          </div>
          {/* Destino */}
          <div className="text-center lg:text-right flex-1 w-full">
            <div className="bg-white rounded-2xl p-6 shadow-lg border border-orange-200 transform transition-all duration-500 hover:scale-105">
              <div className="w-20 h-20 bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto lg:mx-auto mb-4 shadow-lg">
                <span className="text-3xl text-white">🏡</span>
              </div>
              <h4 className="font-bold text-gray-800 text-lg mb-2">
                {isPickup ? 'Recoge en Origen' : 'Destino'}
              </h4>
              <p className="font-semibold text-orange-600 text-lg">
                {destination.destination?.toUpperCase() ||
                  destination.name?.toUpperCase() ||
                  ''}
              </p>

              {/*
                <p className="text-gray-600 text-sm mt-2">
                  {destination.destination === destination.name
                    ? destination.postalCode
                    : destination.destination}
                </p>
                */}
              {destination.city && destination.state && (
                <p className="text-gray-500 text-sm">
                  {destination.city}, {destination.state}
                </p>
              )}
            </div>
          </div>
        </div>
        {/* Indicador móvil */}
        <div className="lg:hidden flex justify-center mt-4">
          <div className="flex items-center animate-pulse">
            <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-16 h-1 bg-gradient-to-r from-blue-400 to-orange-400 mx-2"></div>
            <div
              className="w-2 h-2 bg-orange-500 rounded-full animate-bounce"
              style={{ animationDelay: '0.2s' }}
            ></div>
          </div>
        </div>
      </div>

      {/* Información de Envío y Tiempos */}
      <div
        className={`
          grid 
          gap-6 lg:gap-8
          ${
            data.MetodoDeEnvioRecoleccionMeaning ||
            data.NumeroDeUnidad_c ||
            data.NumeroDeTiros_c ||
            data.NombreDeChofer_c ||
            isExternalCourier ||
            isPickup
              ? 'grid-cols-1 lg:grid-cols-2'
              : 'grid-cols-1'
          }
        `}
      >
        {/* Información de Envío Mejorada */}
        {(data.MetodoDeEnvioRecoleccionMeaning ||
          data.NumeroDeUnidad_c ||
          data.NumeroDeTiros_c ||
          data.NombreDeChofer_c ||
          isExternalCourier ||
          isPickup) && (
          <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 transform transition-all duration-700 hover:shadow-3xl">
            <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
              <span className="text-2xl">🚚</span>
              Información de Envío
            </h3>
            <div className="space-y-4">
              {data.MetodoDeEnvioRecoleccionMeaning && (
                <div className="flex justify-between items-center py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-colors">
                  <span className="font-semibold text-gray-600 flex items-center gap-2">
                    <span>📦</span> Método:
                  </span>
                  <span className="text-gray-800 font-medium text-right">
                    {data.MetodoDeEnvioRecoleccionMeaning}
                  </span>
                </div>
              )}

              {data.NumeroDeUnidad_c && (
                <div className="flex justify-between items-center py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-colors">
                  <span className="font-semibold text-gray-600 flex items-center gap-2">
                    <span>🚛</span> Unidad:
                  </span>
                  <span className="text-gray-800 font-medium">
                    {data.NumeroDeUnidad_c}
                  </span>
                </div>
              )}

              {data.NumeroDeTiros_c && (
                <div className="flex justify-between items-center py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-colors">
                  <span className="font-semibold text-gray-600 flex items-center gap-2">
                    <span>📍</span> No. Entrega:
                  </span>
                  <span className="text-gray-800 font-medium">
                    #{data.NumeroDeTiros_c}
                  </span>
                </div>
              )}

              {/*
              {data.NombreDeChofer_c && (
                <div className="flex justify-between items-center py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-colors">
                  <span className="font-semibold text-gray-600 flex items-center gap-2">
                    <span>👤</span> Chofer:
                  </span>
                  <span className="text-gray-800 font-medium">
                    {data.NombreDeChofer_c}
                  </span>
                </div>
              )}
                */}

              {/* Información de Guía para Paquetería Externa */}
              {isExternalCourier && (
                <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl p-4 border border-orange-200">
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="font-semibold text-orange-700 flex items-center gap-2">
                        <span>📮</span> Guía de Paquetería:
                      </span>
                      <p className="text-orange-600 font-bold text-lg mt-1">
                        {data.Guia_c}
                      </p>
                    </div>
                    <a
                      href={`https://paquetexpress.com.mx/rastreo/${data.Guia_c}`}
                      className="bg-orange-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-orange-600 transition-colors shadow-lg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Rastrear
                    </a>
                  </div>
                </div>
              )}

              {/* Mensaje especial para recogida en tienda */}
              {isPickup && (
                <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-xl p-4 border border-purple-200">
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">🏪</span>
                    <div>
                      <p className="font-semibold text-purple-700">
                        Recogida en Tienda
                      </p>
                      <p className="text-purple-600 text-sm mt-1">
                        Este pedido debe ser recogido directamente en nuestras
                        instalaciones
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Línea de Tiempo Detallada */}
        <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 transform transition-all duration-700 hover:shadow-3xl">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
            <span className="text-2xl">⏰</span>
            Línea de Tiempo Detallada
          </h3>
          <div className="space-y-4">
            {data.MetodoDeEnvioRecoleccionMeaning === 'Ruta Packsys' &&
              [
                {
                  key: 'CreationDate',
                  label: 'Creación del Pedido',
                  details: 'Tu pedido ha sido registrado en el sistema',
                  icon: '📝',
                },
                {
                  key: 'HorarioDeSalidaDeUnidad_c',
                  label: 'Unidad en Tránsito',
                  details: 'Tu pedido está en camino',
                  icon: '🚚',
                },
                /*
                {
                  key: 'HorarioLlegada_c',
                  label: 'Llegada al Destino',
                  details: 'Tu pedido ha llegado al destino',
                  icon: '🏠',
                },
                {
                  key: 'HorarioInicioDescarga_c',
                  label: 'Inicio de Descarga',
                  details: 'En proceso de descarga',
                  icon: '📦',
                },*/
                {
                  key: 'HorarioSalida_c',
                  label: 'Finalización',
                  details: isPickup
                    ? 'Pedido recogido exitosamente'
                    : 'Pedido entregado exitosamente',
                  icon: '✅',
                },
              ].map(
                (item, index) =>
                  data[item.key] && (
                    <div
                      key={item.key}
                      className="flex items-center gap-4 py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-all duration-300 transform hover:scale-105"
                      style={{ transitionDelay: `50ms` }}
                    >
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                        <span className="text-white text-lg">{item.icon}</span>
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-700 text-sm">
                          {item.label}
                        </p>
                        <p className="font-semibold text-gray-700 text-sm mb-2">
                          {item.details}
                        </p>
                        <p className="text-gray-800 font-medium text-sm">
                          {formatDate(data[item.key])}
                        </p>
                      </div>
                    </div>
                  )
              )}

            {data.MetodoDeEnvioRecoleccionMeaning === 'Paquetería domicilio' &&
              [
                {
                  key: 'CreationDate',
                  label: 'Creación del Pedido',
                  details: 'Tu pedido ha sido registrado en el sistema',
                  icon: '📝',
                },
                {
                  key: 'HorarioSalida_c',
                  label: 'Envío por Paquetería',
                  details: 'Tu pedido ha sido enviado con paquetería externa',
                  icon: '📮',
                },
                {
                  key: 'HorarioSalida_c',
                  label: 'Finalización',
                  details: 'Pedido entregado exitosamente',
                  icon: '✅',
                },
              ].map(
                (item, index) =>
                  data[item.key] && (
                    <div
                      key={item.key}
                      className="flex items-center gap-4 py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-all duration-300 transform hover:scale-105"
                      style={{ transitionDelay: `50ms` }}
                    >
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                        <span className="text-white text-lg">{item.icon}</span>
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-700 text-sm">
                          {item.label}
                        </p>
                        <p className="font-semibold text-gray-700 text-sm mb-2">
                          {item.details}
                        </p>
                        <p className="text-gray-800 font-medium text-sm">
                          {formatDate(data[item.key])}
                        </p>
                      </div>
                    </div>
                  )
              )}

            {data.MetodoDeEnvioRecoleccionMeaning === 'Cliente recoge' &&
              [
                {
                  key: 'CreationDate',
                  label: 'Creación del Pedido',
                  details: 'Tu pedido ha sido registrado en el sistema',
                  icon: '📝',
                },
                {
                  key: 'HorarioSalida_c',
                  label: 'Finalización',
                  details: 'Pedido recogido exitosamente',
                  icon: '✅',
                },
              ].map(
                (item, index) =>
                  data[item.key] && (
                    <div
                      key={item.key}
                      className="flex items-center gap-4 py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-all duration-300 transform hover:scale-105"
                      style={{ transitionDelay: `50ms` }}
                    >
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                        <span className="text-white text-lg">{item.icon}</span>
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-700 text-sm">
                          {item.label}
                        </p>
                        <p className="font-semibold text-gray-700 text-sm mb-2">
                          {item.details}
                        </p>
                        <p className="text-gray-800 font-medium text-sm">
                          {formatDate(data[item.key])}
                        </p>
                      </div>
                    </div>
                  )
              )}

            {(!data.MetodoDeEnvioRecoleccionMeaning ||
              ![
                'Ruta Packsys',
                'Paquetería domicilio',
                'Cliente recoge',
              ].includes(data.MetodoDeEnvioRecoleccionMeaning)) &&
              [
                {
                  key: 'CreationDate',
                  label: 'Creación del Pedido',
                  details: 'Tu pedido ha sido registrado en el sistema',
                  icon: '📝',
                },
                {
                  key: 'HorarioDeSalidaDeUnidad_c',
                  label: 'Unidad en Tránsito',
                  details: 'Tu pedido está en camino',
                  icon: '🚚',
                },
                {
                  key: 'HorarioLlegada_c',
                  label: 'Llegada al Destino',
                  details: 'Tu pedido ha llegado al destino',
                  icon: '🏠',
                },
                {
                  key: 'HorarioInicioDescarga_c',
                  label: 'Inicio de Descarga',
                  details: 'En proceso de descarga',
                  icon: '📦',
                },
                {
                  key: 'HorarioSalida_c',
                  label: 'Finalización',
                  details: isPickup
                    ? 'Pedido recogido exitosamente'
                    : 'Pedido entregado exitosamente',
                  icon: '✅',
                },
              ].map(
                (item, index) =>
                  data[item.key] && (
                    <div
                      key={item.key}
                      className="flex items-center gap-4 py-3 border-b border-gray-100 hover:bg-gray-50 rounded-lg px-3 transition-all duration-300 transform hover:scale-105"
                      style={{ transitionDelay: `50ms` }}
                    >
                      <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                        <span className="text-white text-lg">{item.icon}</span>
                      </div>
                      <div className="flex-1">
                        <p className="font-bold text-gray-700 text-sm">
                          {item.label}
                        </p>
                        <p className="font-semibold text-gray-700 text-sm mb-2">
                          {item.details}
                        </p>
                        <p className="text-gray-800 font-medium text-sm">
                          {formatDate(data[item.key])}
                        </p>
                      </div>
                    </div>
                  )
              )}
          </div>
        </div>
      </div>

      {/* Información Adicional Mejorada */}
      {(data.ProblemDescription ||
        data.Vendedor_c ||
        data.AssigneePersonName ||
        data.NumeroDeFactura_c ||
        data.CondicionesDeCreditoDeLaOrden_c) && (
        <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 transform transition-all duration-700 hover:shadow-3xl">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center flex items-center justify-center gap-3">
            <span className="text-2xl">📋</span>
            Información Adicional
          </h3>

          {/* Contador de elementos visibles */}
          {(() => {
            const visibleItems = [
              data.Vendedor_c && 'Vendedor_c',
              data.AssigneePersonName && 'AssigneePersonName',
              data.NumeroDeFactura_c && 'NumeroDeFactura_c',
              data.CondicionesDeCreditoDeLaOrden_c &&
                'CondicionesDeCreditoDeLaOrden_c',
              data.OrigenDeOrden_c && 'OrigenDeOrden_c',
            ].filter(Boolean);

            // Determina las columnas según la cantidad de elementos
            const gridCols =
              visibleItems.length === 1
                ? 'grid-cols-1 max-w-md mx-auto'
                : visibleItems.length === 2
                  ? 'grid-cols-1 md:grid-cols-2'
                  : visibleItems.length === 3
                    ? 'grid-cols-1 md:grid-cols-3'
                    : visibleItems.length === 4
                      ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
                      : 'grid-cols-1 md:grid-cols-3 lg:grid-cols-5';

            return (
              <div
                className={`grid ${gridCols} gap-5 justify-items-center items-center`}
              >
                {data.Vendedor_c && (
                  <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-4 border border-blue-200 shadow-sm w-full max-w-xs">
                    <span className="font-semibold text-blue-700 text-sm block mb-2">
                      Vendedor
                    </span>
                    <span className="text-gray-800 font-medium">
                      {data.Vendedor_c}
                    </span>
                  </div>
                )}

                {data.AssigneePersonName && (
                  <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-4 border border-red-200 shadow-sm w-full max-w-xs">
                    <span className="font-semibold text-red-700 text-sm block mb-2">
                      Servicio al Cliente
                    </span>
                    <span className="text-gray-800 font-medium">
                      {data.AssigneePersonName}
                    </span>
                  </div>
                )}

                {data.NumeroDeFactura_c && (
                  <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-4 border border-green-200 shadow-sm w-full max-w-xs">
                    <span className="font-semibold text-green-700 text-sm block mb-2">
                      Factura
                    </span>
                    <span className="text-gray-800 font-medium">
                      {data.NumeroDeFactura_c}
                    </span>
                  </div>
                )}

                {data.CondicionesDeCreditoDeLaOrden_c && (
                  <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-4 border border-purple-200 shadow-sm w-full max-w-xs">
                    <span className="font-semibold text-purple-700 text-sm block mb-2">
                      Condiciones de Crédito
                    </span>
                    <span className="text-gray-800 font-medium text-sm">
                      {data.CondicionesDeCreditoDeLaOrden_c}
                    </span>
                  </div>
                )}

                {data.OrigenDeOrden_c && (
                  <div className="bg-gradient-to-br from-orange-50 to-amber-100 rounded-2xl p-4 border border-orange-200 shadow-sm w-full max-w-xs">
                    <span className="font-semibold text-orange-700 text-sm block mb-2">
                      Origen de Orden
                    </span>
                    <span className="text-gray-800 font-medium">
                      {data.OrigenDeOrden_c}
                    </span>
                  </div>
                )}
              </div>
            );
          })()}

          {/*
          {data.ProblemDescription && (
            <div className="mt-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 border border-gray-200">
              <span className="font-semibold text-gray-700 block mb-3 text-lg">
                Descripción del Pedido
              </span>
              <p className="text-gray-800 leading-relaxed whitespace-pre-wrap">
                {data.ProblemDescription}
              </p>
            </div>
          )}}
          */}
        </div>
      )}

      {/* Botón Nueva Búsqueda Mejorado */}
      <div className="text-center pt-6 lg:pt-8">
        <a
          href="/"
          className="inline-block bg-gradient-to-r from-packsys-orange to-orange-600 text-white px-12 py-4 rounded-2xl font-bold text-lg hover:from-orange-600 hover:to-orange-700 transition-all duration-300 shadow-2xl hover:shadow-3xl transform hover:scale-105 active:scale-95"
        >
          <span className="flex items-center justify-center gap-3">
            <span className="text-xl">🔍</span>
            Realizar Nueva Búsqueda
          </span>
        </a>
      </div>
    </div>
  );
};

export default TrackingResults;
